import styles from "./AlterarPerfil.module.css";
import newImageIcon from "../../assets/newImageIcon.svg";
import { useTranslation } from "react-i18next";
import React, { ChangeEvent, useEffect, useState } from "react";
import api from "../../utils/axios/api";
import InputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";

const AlterarPerfil = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");

  const [clientName, setprofileName] = useState<string>("");
  const [clientCPF, setprofileCPF] = useState<string>("");
  const [clientEmail, setprofileEmail] = useState<string>("");
  const [clientPhone, setprofilePhone] = useState<string>("");
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [profileImageFile, setProfileImageFile] = useState<File | null>(null);

  const handleInputFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setProfileImageFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target && typeof e.target.result === "string") {
          setSelectedImage(e.target.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmitForm = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!clientName || !clientCPF || !clientEmail || !clientPhone) {
      console.error("Por favor, preencha todos os campos obrigatórios.");
      return;
    }

    if (!userId) {
      console.error("Usuário não identificado.");
      return;
    }

    try {
      const { data: u } = await api.get(`/user/${userId}`);

      const formData = new FormData();
      formData.append("name", clientName);
      formData.append("email", u.email);
      formData.append("isUserDeleted", String(u.isUserDeleted));
      formData.append("confirmedEmail", String(u.confirmedEmail));
      formData.append("document", clientCPF);
      formData.append("documentType", u.documentType);
      formData.append("role", u.role);
      formData.append("telephone", clientPhone);
      formData.append("image", u.image ?? "");

      if (u.entrepeneur) {
        formData.append("account", u.entrepeneur.account);
        formData.append("agency", u.entrepeneur.agency);
        formData.append("pix", u.entrepeneur.pix);
      }

      if (profileImageFile) {
        formData.append("file", profileImageFile);
      }

      await api.put(`/user/${userId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      window.alert(`${t(`accountMenu.userProfileUpdated`)}!`);
      window.scrollTo(0, 0);
      navigate("/auth/client/account/profile");
    } catch (error) {
      console.error("Error getting/updating user/client: ", error);
    }
  };

  useEffect(() => {
    if (!userId) return;
    api.get(`/user/${userId}`).then((response) => {
      const user = response.data;
      setprofileName(user.name);
      setprofileCPF(user.document);
      setprofileEmail(user.email);
      setprofilePhone(user.telephone);
      setSelectedImage(user.image ?? null);
      setProfileImageFile(null);
    });
  }, [userId]);

  return (
    <main className={styles.main_container}>
      <section className={styles.section_container}>
        <h1>{t(`alterarPerfil.changeProfile`)}</h1>
        <form className={styles.profileContainer} onSubmit={handleSubmitForm}>
          <div className={styles.profileDataContainer}>
            <div className={styles.profileFotoContainer}>
              <p className={styles.paragraphSubtitle}>
                {t(`alterarPerfil.photo`)}
              </p>
              <div className={styles.productImagesContainer}>
                <label htmlFor="uploadInput" className={styles.customFileInput}>
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="Selected Image"
                      className={styles.selectedImage}
                    />
                  ) : (
                    <img src={newImageIcon} alt="Add Image" />
                  )}
                </label>

                <input
                  className={styles.uploadInput}
                  type="file"
                  name="uploadInput"
                  id="uploadInput"
                  accept="image/*"
                  onChange={(event) => handleInputFileChange(event)}
                />
              </div>
            </div>
            <div className={styles.profileNameContainer}>
              <p className={styles.paragraphSubtitle}>
                {t(`alterarPerfil.name`)}
              </p>
              <input
                type="text"
                placeholder={t(`alterarPerfil.name`)}
                name="name"
                value={clientName}
                onChange={(event) => setprofileName(event.currentTarget.value)}
                required
              />
            </div>
            <div className={styles.profileNameContainer}>
              <p className={styles.paragraphSubtitle}>{t(`alterarPerfil.cpf`)}</p>
              <input
                type="text"
                placeholder={clientCPF}
                name="CPF"
                readOnly
              />
            </div>
            <div className={styles.profileNameContainer}>
              <p className={styles.paragraphSubtitle}>
                {t(`alterarPerfil.email`)}
              </p>
              <input
                type="text"
                placeholder={clientEmail}
                name="Email"
                readOnly
              />
            </div>
            <div className={styles.profileNameContainer}>
              <p className={styles.paragraphSubtitle}>
                {t(`alterarPerfil.phone`)}
              </p>
              <InputMask
                type="text"
                mask="(99) 99999-9999"
                placeholder={t(`alterarPerfil.phone`)}
                name="Telefone"
                value={clientPhone}
                onChange={(event) => setprofilePhone(event.currentTarget.value)}
                required
              />
            </div>
            <button type="submit">{t("alterarPerfil.save")}</button>
          </div>
        </form>
      </section>
    </main>
  );
};

export default AlterarPerfil;
